/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled from 'styled-components';
import {mediaHelper} from "../../utils/src";

export const RootRoleWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  gap: 20px;
  margin-left: 40px;
  margin-bottom: 10px;

  @media (max-width: 768px) {
    flex-direction: column;
    margin-left: 0;
  }
`;

export const HalfWidthWrapper = styled.div`
  width: 50%;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const CheckBoxLabelContainer = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 800;
  margin-right: 20px;

  @media (min-width: 1024px) {
    span {
      margin-left: 16px;
    }
  }
`;